import { resolveTheme, onAccent } from '../../designTokens';

const SIZES = {
  default: { padding: '9px 18px', fontSize: '0.875em' },
  sm:      { padding: '5px 12px', fontSize: '0.82em' },
};

export default function Button({ theme, variant = 'primary', onClick, disabled, loading, children, size = 'default', style, ...rest }) {
  const t = theme || resolveTheme();
  const sz = SIZES[size] || SIZES.default;

  const base = {
    border: 'none',
    borderRadius: t.btn_radius,
    cursor: disabled || loading ? 'default' : 'pointer',
    fontWeight: '500',
    transition: 'opacity 0.12s',
    opacity: disabled || loading ? 0.55 : 1,
    ...sz,
    ...style,
  };

  const variants = {
    primary: {
      background: t.accent,
      color: onAccent(t.accent),
    },
    secondary: {
      background: 'white',
      border: `1px solid ${t.card_border}`,
      color: t.text_secondary,
    },
    tertiary: {
      background: t.accent_soft_bg,
      color: t.accent_soft_text,
    },
    // T-16 D2: borttagning är alltid röd/neutral, aldrig accent.
    danger: {
      background: 'white',
      border: '1px solid #F3C4C4',
      color: '#B91C1C',
    },
  };

  return (
    <button
      onClick={!disabled && !loading ? onClick : undefined}
      disabled={disabled || loading}
      style={{ ...base, ...variants[variant] }}
      {...rest}
    >
      {loading ? 'Laddar...' : children}
    </button>
  );
}
